let AppConfig = {
    id: '5db054fadd74b4130864041b',
    Icons: {
        appIconName: '',
    },
    Images: {
        AppHeaderImage: '',
    },
    Headings: {
        AppLogoText: 'Obsidian Tx - SWFT-1030',
        MainAppHeading: 'SWFT',
        sectionAppHeading: 'Obsidian Tx - SWFT-1030',
        sectionQuestionsHeading: 'Obsidian Tx - SWFT-1030',
    },
    UserTimeZone: 'Asia/Kolkata', //'America/New_York',//'Asia/Kolkata',
    DateFormats: {
        NoTimeDate:"MM/DD/YYYY",
        dateFormat: 'DD-MM-YYYY hh:mm:ss A',
        viewFormDateFormat: 'DD-MM-YYYY hh:mm:ss A (zZ)',
        flatPickrOutputFormat: 'YYYY-MM-DD HH:mm:ss',
        flatPickrInputFormat: 'MM/DD/YYYY hh:mm A',
        utcDateFormat: 'YYYY-MM-DDTHH:mm:SSZ',
    },
    ActivityForm: {
        FormRedirectionTimmer:2500,
        IdParam:'ID',
        ParentIdParam: 'PARENTID',
        CloneTimeParam: 'CLONETIME',
        ViewParam:'VIEW',
        OfcAndIndiActivityType:'Single',
        TBDRejectDispName: 'TBD',
        TBDRejectShiftId: 1,
        showTBD: true,
        AtivityDateFormat: 'YYYY-MM-DDT00:00:00',
        NoShiftsErrorMsg: 'No shifts to Display',
        NoLocationEquipmentErrorMsg: 'No Locations and activities',
        ErrorDataFetchMessage: 'Error: Fetch failed to get Shift-Location-Equipment Data.Please inform the administration',
        ErrorValidationMessage: 'Please complete the required fields before proceeding to save the form.',
        ErrorLSADataFetchMessage: 'Error: Fetch failed to get Shift-Location-Availability Data for the table.Please inform the administration',
        CreationErrorMessage:'Activity Creation failed.\n',
        CloneErrorMessage:'Activity Clone failed.\n',
        UpdateErrorMessage:'Activity Update failed.\n',
        DeleteErrorMessage:'Activity Delete failed.\n',
        FullyBookedAlertMsg:'The location(s) are fully booked for the selected shift(s) and day.',
        FullyBookedDialogMsg:'The location(s) are fully booked for the selected shift(s) and day. By clicking, yes below, you are acknowledging that your booking will create an overcapacity scenario. By proceeding with this, you are fully responsible for ensuring that this overcapacity conflict is mitigated prior to this event. Failure to comply is going against established work rules, and compromising the health and safety of others.',
        officeSpaceUsageLocation: process.env.REACT_APP_OFFICE_LOCATION_ID?parseInt(process.env.REACT_APP_OFFICE_LOCATION_ID):17,
        officeSpaceUsageLocationName:  process.env.REACT_APP_OFFICE_LOCATION_NAME?process.env.REACT_APP_OFFICE_LOCATION_NAME:"Office",
        MaxDate:  process.env.REACT_APP_MAX_DATE?process.env.REACT_APP_MAX_DATE:"02/28/2021",
        MinDate:  process.env.REACT_APP_MIN_DATE?process.env.REACT_APP_MIN_DATE:'2021-03-01',
        InactiveStatusId: 2,        
        ActiveStatusId: 1,
        MyStandAloneActStr:"Stand-alone Activities",
        BannerDocURL:  process.env.REACT_APP_BANNER_DOC_URL?process.env.REACT_APP_BANNER_DOC_URL:"https://obsidiantx.sharepoint.com/sites/cytoIT/SitePages/SWFT-Shift-Changes.aspx"
    },
    Calendar: {
        Heading: 'Activity Calendar',
        NextDateDispString: 'ddd DD-MMM',
        CalendarDateFormat: 'YYYY-MM-DDT00:00:00'
    },
    OutLook:{
        TimeZoneString:"Eastern Standard Time",
        ShiftOrderNameString:"Shift ",
        DefaultBodyAppendMsg:"<br><a color='red'>This activity has been added to your Outlook calendar. Please note that changes to your Outlook calendar will not update this SWFT entry."
    },
    PlanExperiment:{
        IdParam: 'ID',
        ParentIdParam: 'PARENTID',
        ViewParam: 'VIEW',
        FormRedirectionTimmer:2000,
        ExpDateFormat: 'YYYY-MM-DDT00:00:00',
    },
    Roles:{
        ActivityRoleId:5,
        ExpRoleId:4,
        SysAmdinRoleId:3,
        PMRoleId:2,
        FMRoleId:1,
    },
    Footer: '© Obsidian Tx 2022',
};
export default AppConfig;
